import { httpDatasul } from './config'

export default {
    listar:(rep) => {
        return httpDatasul.get('emitenteRepres/' + rep)
    },
    detalhe:(cgc) => {
        return httpDatasul.get('emitenteDetalhe/' + cgc)
    },
    valores:(cgc) => {
        return httpDatasul.get('emitenteValores/' + cgc)
    },
    financeiro:(cgc) => {
        return httpDatasul.get('emitenteFinanc/' + cgc)
    },
    matrizCredito:(cgc) => {
        return httpDatasul.get('consultaCreditoMatriz/' + cgc)
    },
    filialCredito:(cgc) => {
        return httpDatasul.get('consultaCreditoCnpj/' + cgc)
    },
    endEntrega:(nomeabrev) => {
        return httpDatasul.get('loc-entr/' + nomeabrev)
    },
    condPagto:() => {
        return httpDatasul.get('condpagto/')
    },
    transporte:() => {
        return httpDatasul.get('transporte/')
    },
    precoItem:(tabpre) => {
        return httpDatasul.get('precoitem/' + tabpre)
    },
    itemInfo:(item) => {
        return httpDatasul.get('item/' + item)
    },
    tabelapreco:() => {
        return httpDatasul.get('tabpre/')
    },
    cubagem:(item) => {
        return httpDatasul.get('itemm3/' + item )
    },
    repres:(data) => {
        return httpDatasul.get('repres/' + data)
    },
    biGerente:(data) => {
        return httpDatasul.get('biGerente/' + data)
    },
    biRepres:(data) => {
        return httpDatasul.get('biRep/' + data + "/a/a/")
    }

}

